var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EE797E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_1756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_1756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1435 51.6501C40.7145 51.6501 41.2116 51.4385 41.635 51.0151C42.058 50.5921 42.2695 50.0891 42.2695 49.5061C42.2695 48.9228 42.058 48.4256 41.635 48.0146C41.2116 47.6036 40.7098 47.3981 40.1295 47.3981C39.5488 47.3981 39.0516 47.6028 38.638 48.0121C38.2243 48.4218 38.0175 48.9245 38.0175 49.5201C38.0175 50.0938 38.2255 50.5921 38.6415 51.0151C39.0578 51.4385 39.5585 51.6501 40.1435 51.6501ZM38.1675 44.3501H41.5415C41.5415 43.5211 41.6498 42.7483 41.8665 42.0316C42.0831 41.315 42.7298 40.5088 43.8065 39.6131C44.8021 38.8218 45.512 37.9981 45.936 37.1421C46.3596 36.2858 46.5715 35.3416 46.5715 34.3096C46.5715 32.489 46.0126 31.0311 44.895 29.9361C43.777 28.8411 42.2641 28.2936 40.3565 28.2936C38.6665 28.2936 37.1636 28.7396 35.848 29.6316C34.532 30.5236 33.5718 31.7255 32.9675 33.2371L36.0695 34.4021C36.4551 33.4501 37.0003 32.7205 37.705 32.2131C38.41 31.7058 39.2061 31.4521 40.0935 31.4521C41.0478 31.4521 41.8396 31.7243 42.469 32.2686C43.0983 32.8126 43.413 33.5245 43.413 34.4041C43.413 35.0681 43.2105 35.7156 42.8055 36.3466C42.4005 36.978 41.8283 37.5965 41.089 38.2021C40.1266 39.0311 39.3991 39.8996 38.9065 40.8076C38.4138 41.7153 38.1675 42.8961 38.1675 44.3501ZM40.004 60.7066C37.155 60.7066 34.4715 60.1668 31.9535 59.0871C29.4358 58.0071 27.2363 56.5265 25.355 54.6451C23.4736 52.7638 21.993 50.5656 20.913 48.0506C19.8333 45.5353 19.2935 42.8531 19.2935 40.0041C19.2935 37.1218 19.8333 34.4216 20.913 31.9036C21.993 29.386 23.4721 27.1943 25.3505 25.3286C27.2288 23.463 29.4263 21.986 31.943 20.8976C34.4596 19.8093 37.1431 19.2651 39.9935 19.2651C42.8775 19.2651 45.5795 19.8086 48.0995 20.8956C50.6198 21.9823 52.812 23.4573 54.676 25.3206C56.5403 27.1836 58.0161 29.3745 59.1035 31.8931C60.1911 34.4118 60.735 37.1141 60.735 40.0001C60.735 42.8518 60.1908 45.5363 59.1025 48.0536C58.0141 50.5713 56.5371 52.7696 54.6715 54.6486C52.8058 56.5276 50.6155 58.0071 48.1005 59.0871C45.5851 60.1668 42.8863 60.7066 40.004 60.7066ZM40 56.7456C44.658 56.7456 48.6135 55.1168 51.8665 51.8591C55.1191 48.6015 56.7455 44.6485 56.7455 40.0001C56.7455 35.3421 55.1191 31.3866 51.8665 28.1336C48.6135 24.881 44.6533 23.2546 39.986 23.2546C35.352 23.2546 31.4048 24.881 28.1445 28.1336C24.8845 31.3866 23.2545 35.3468 23.2545 40.0141C23.2545 44.6481 24.8833 48.5953 28.141 51.8556C31.3986 55.1156 35.3516 56.7456 40 56.7456Z",
    fill: "#0B0E4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2444d0b44a8b37caee1b13d0dd8e3882.svg";
export { ForwardRef as ReactComponent };